import { Check, X, AlertTriangle } from 'lucide-react';

// Big (48px) circle for complete/current/error/cancelled steps; a small
// muted dot for steps not yet reached. All sit inside a fixed-size wrapper
// so the connecting line -- offset by exactly half the wrapper height --
// stays centered on every circle regardless of which size renders.
const WRAPPER = 'w-4 h-4';

const STEP_VISUALS = {
	complete: { bg: 'bg-black', size: 'w-4 h-4', icon: Check, label: 'text-black' },
	current: { bg: 'bg-black', size: 'w-4 h-4', icon: null, label: 'text-black' },
	error: { bg: 'bg-pi-red', size: 'w-4 h-4', icon: AlertTriangle, label: 'text-pi-red' },
	cancelled: { bg: 'bg-pi-red', size: 'w-4 h-4', icon: X, label: 'text-pi-red' },
	upcoming: { bg: 'bg-gray-300', size: 'w-3 h-3', icon: null, label: 'text-gray-400' },
};

// Back Order/Hold are sub-statuses of "In Process" (see orderStatus.js's
// getJourneySteps) that only exist to color the header/list badges
// elsewhere -- the journey stepper itself always shows plain "In Process",
// so both normalize to the same visual as 'current' here. 'partner'
// (custom-fulfillment-only orders) is the same: its label already reads
// "Sent to partner", it just renders as the current step.
const normalizeStepStatus = (status) =>
	status === 'backorder' || status === 'hold' || status === 'partner' ? 'current' : status;

/** steps: [{ key, label, status: 'complete'|'current'|'backorder'|'hold'|'partner'|'error'|'cancelled'|'upcoming' }] */
export default function OrderJourneyStepper({ steps }) {
	return (
		<div className='flex items-start'>
			{steps.map((step, i) => {
				const visualStatus = normalizeStepStatus(step.status);
				const visual = STEP_VISUALS[visualStatus] || STEP_VISUALS.upcoming;
				const Icon = visual.icon;
				const isLast = i === steps.length - 1;
				const lineColor = visualStatus === 'complete' ? 'bg-gray-400' : 'bg-gray-200';
				return (
					<div key={step.key} className={`flex items-center ${isLast ? '' : 'flex-1'}`}>
						<div className='flex flex-col items-center'>
							<div className={`${WRAPPER} flex items-center justify-center shrink-0`}>
								<div className={`${visual.size} rounded-full flex items-center justify-center ${visual.bg}`}>
									{Icon && <Icon className='size-2.5 text-white' strokeWidth={2} />}
									{visualStatus === 'current' && <div className='w-3 h-3 rounded-full bg-white' />}
								</div>
							</div>
							<span className={`text-xs font-semibold tracking-wide uppercase mt-2x whitespace-nowrap ${visual.label}`}>
								{step.label}
							</span>
						</div>
						{!isLast && <div className={`h-0.5 flex-1 mx-1 mt-4 ${lineColor}`} />}
					</div>
				);
			})}
		</div>
	);
}
